import React, { useEffect } from "react";

export default function Modal({ open, onClose, title, children, footer, testId = "modal" }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape" && open) onClose?.(); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;
    return (
        <div className="modal-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }} data-testid={testId}>
            <div className="modal" role="dialog" aria-modal="true">
                <div className="modal-head">
                    <h3>{title}</h3>
                    <button className="btn btn-ghost btn-sm" onClick={onClose} data-testid={`${testId}-close`}>Cerrar</button>
                </div>
                <div className="modal-body">{children}</div>
                {footer && <div className="modal-foot">{footer}</div>}
            </div>
        </div>
    );
}
